import { render, staticRenderFns } from "./MinMax.vue?vue&type=template&id=564f57cc&scoped=true&"
import script from "./MinMax.vue?vue&type=script&lang=js&"
export * from "./MinMax.vue?vue&type=script&lang=js&"
import style0 from "./MinMax.vue?vue&type=style&index=0&id=564f57cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f57cc",
  null
  
)

export default component.exports